export class OrderAlreadyClaimedException extends Error {
  constructor() {
    super('This order is already claimed');
  }
}
